import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import Wrapper from './Wrapper';
import "./i18n.js";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <Wrapper />
  // </React.StrictMode>
);
